import React from 'react'
import { FaCheckSquare } from 'react-icons/fa';

const SectionAboutFaq = () => {

    const faqList = [
        { title: "Un processus de réservation simple et rapide." },
        { title: "Un large éventail de véhicules et de propriétés adaptées à tous les besoins." },
        { title: "Une équipe de support dédiée prête à vous aider à chaque étape." },
        { title: "Des offres spéciales et des promotions régulières pour vous faire économiser." },
        { title: "Des avis clients élogieux et un taux de satisfaction élevé." },
    ];


    return (
        <div className="container-fluid" style={{ position: "relative" }}>
            <div  className="container">
                <div className="py-5" style={{ display: "flex", justifyContent: "center" }}>

                    <div className="" style={{ position:"relative", zIndex:55 }}>
                        <div><h3 style={{ color: "#737373", fontSize: "43px" }} className="text-center">Pourquoi choisir Mareza ? </h3></div>
                        <div className="mt-3 pt-3 pb-4" style={{ display: "flex", width: "100%", justifyContent: "center", flexDirection: "column" }}>
                            <p className="text-dark text-center">
                                Chez Mareza, nous nous engageons à offrir à nos clients une  expérience de réservation exceptionnelle.<br /> Voici quelques raisons pour  lesquelles vous devriez nous choisir .
                            </p>
                        </div>
                        <div className="p-5 bg-white shadow-sm rounded-lg">
                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", padding: "10px" }}>

                                {
                                    faqList.map((item) => {
                                        return (
                                            <div className="py-4 border-bottom">
                                                <p><span><FaCheckSquare color={"#42B711"} size={25} /> </span> {item.title}</p>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ position: "absolute", zIndex: 50, top: 50, right: 10 }}>
                <img src="design/images/Vector_design.png" alt="illustration" />
            </div>
        </div>
    )
}

export default SectionAboutFaq